<div class="managingOrgFacility" *ngIf="formId">
    <span class="dynamic-form-title">{{title | translate}}</span>
    <div *ngIf="isFacilityEnabled" class="facility-dropdown">
        <dls-combobox [(ngModel)]="selectedFacility"
                      (ngModelChange)="onselect($event)"
                      placeholder="Select Facility"
                      name="selectedFacility"
                      [disabled]="disabled">
            <dls-option *ngFor="let facility of currentFacilities"
                        [value]="facility.id">{{facility.name}}
            </dls-option>
        </dls-combobox>
    </div>
    <gen-dynamic-form
            [formName]="formId"
            [formData]="formData"
            (formChange)="emit($event.form)"
            [listenToDataChange]="true"
            [editMode]="true"
            [disabled]="disabled"
            [submitted]="widgetFormInstanceSubmitted"
            (validateChange)="updateValidate($event)"
    ></gen-dynamic-form>
</div>
